/**
 * Opens the ET-Wechsel (Eigentümerwechsel) dialog for the Owner Contract Editor.
 * Run on the OLD owner contract; API resolves the ACTIVE (new) owner for the unit.
 * URL pattern: /properties/{propertyHrId}/edit/unit/{unitId}/contract/all/edit/{oldContractId}
 * Stichtag defaults to today; user can change it in the dialog.
 */
async function openEtWechselDialog() {
  const urlPath = window.location.pathname
  const propertyMatch = urlPath.match(/properties\/([^/]+)\//)
  const unitMatch = urlPath.match(/\/unit\/([^/]+)\//)
  const contractMatch = urlPath.match(/contract\/all\/edit\/([^/?]+)/)
  const propertyHrId = propertyMatch ? propertyMatch[1] : null
  const unitId = unitMatch ? unitMatch[1] : null
  const oldContractId = contractMatch ? contractMatch[1] : null
  if (!propertyHrId || !unitId || !oldContractId) {
    alert('Kontext konnte nicht ermittelt werden (propertyHrId, unitId oder Vertrags-ID aus URL).')
    return
  }

  const stichtagDefault = new Date().toISOString().slice(0, 10)

  const overlay = document.createElement('div')
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:10000;display:flex;align-items:center;justify-content:center;'
  const box = document.createElement('div')
  box.style.cssText = 'background:#fff;padding:28px 32px;border-radius:10px;box-shadow:0 8px 32px rgba(0,0,0,0.12);min-width:440px;max-width:90vw;font-size:16px;'
  box.innerHTML = `
    <div style="display:flex;align-items:stretch;gap:14px;margin-bottom:24px;">
      <div style="flex-shrink:0;width:40px;height:40px;border-radius:50%;background:#fff3e0;color:#e65100;font-size:1.5rem;font-weight:700;display:flex;align-items:center;justify-content:center;">!</div>
      <div style="height:40px;display:flex;flex-direction:column;justify-content:space-between;">
        <h2 style="margin:0;font-size:1.35rem;font-weight:700;color:#1a1a1a;line-height:1.2;">ET-Wechsel</h2>
        <p style="margin:0;font-size:1rem;color:#555;line-height:1.2;">Stichtag und Optionen für die Verarbeitung.</p>
      </div>
    </div>
    <div style="margin-bottom:20px;">
      <label style="display:block;margin-bottom:8px;font-weight:500;font-size:1rem;color:#333;">Stichtag ET-Wechsel</label>
      <div id="et-wechsel-stichtag-mount"></div>
    </div>
    <div style="margin-bottom:18px;">
      <label style="display:flex;align-items:center;gap:10px;cursor:pointer;font-size:1.125rem;">
        <input type="checkbox" id="et-wechsel-sollstellungen" checked style="width:20px;height:20px;" />
        <span style="color:#1a1a1a;">Sollstellungen verarbeiten</span>
      </label>
      <p style="margin:6px 0 0 30px;font-size:1.0625rem;color:#666;line-height:1.5;">Rückwirkende Sollstellungen für den neuen ET (Hausgeld, Rücklage) als manuelle Umbuchungen.</p>
    </div>
    <div style="margin-bottom:18px;opacity:0.55;pointer-events:none;" title="Noch nicht verfügbar">
      <label style="display:flex;align-items:center;gap:10px;cursor:not-allowed;font-size:1.125rem;">
        <input type="checkbox" id="et-wechsel-lastschriften" disabled style="width:20px;height:20px;" />
        <span style="color:#666;">Lastschriften verarbeiten</span>
      </label>
      <p style="margin:6px 0 0 30px;font-size:1.0625rem;color:#999;">Lastschriftdatei(en) für den rückwirkenden Zeitraum (nur bei gültigem SEPA-Mandat des neuen ET).</p>
    </div>
    <div style="margin-bottom:24px;opacity:0.55;pointer-events:none;" title="Noch nicht verfügbar">
      <label style="display:flex;align-items:center;gap:10px;cursor:not-allowed;font-size:1.125rem;">
        <input type="checkbox" id="et-wechsel-bereits-gezahlt" disabled style="width:20px;height:20px;" />
        <span style="color:#666;">Bereits gezahlte Hausgelder des alten ET berücksichtigen</span>
      </label>
      <p style="margin:6px 0 0 30px;font-size:1.0625rem;color:#999;">Falls aktiv: Erstellung einer Auszahlungsdatei (Erstattung an alten ET).</p>
    </div>
    <div id="et-wechsel-footer-buttons" style="display:flex;gap:12px;justify-content:flex-end;margin-top:28px;padding-top:20px;border-top:1px solid #f0f0f0;"></div>
  `

  overlay.appendChild(box)
  document.body.appendChild(overlay)

  const stichtagMount = box.querySelector('#et-wechsel-stichtag-mount')
  const stichtagPicker = datePicker('et-wechsel-stichtag')
  stichtagPicker.wrapper.id = 'et-wechsel-stichtag'
  stichtagPicker.setValue(stichtagDefault)
  stichtagPicker.setDisabled(false)
  if (stichtagMount) stichtagMount.replaceWith(stichtagPicker.wrapper)

  const footerContainer = box.querySelector('#et-wechsel-footer-buttons')
  const headerButtons = document.querySelector('.header-buttons')
  const templateBtn = (headerButtons && headerButtons.firstElementChild)
    ? headerButtons.firstElementChild.cloneNode(true)
    : null
  let cancelBtnEl
  let confirmBtnEl
  if (templateBtn) {
    templateBtn.innerHTML = ''
    templateBtn.id = ''
    const cancelBtn = templateBtn.cloneNode(true)
    cancelBtn.id = 'et-wechsel-cancel'
    cancelBtn.type = 'button'
    cancelBtn.textContent = 'Abbrechen'
    cancelBtn.style.backgroundColor = '#fff'
    cancelBtn.style.color = '#000'
    cancelBtn.style.border = '1px solid #000'
    const confirmBtn = templateBtn.cloneNode(true)
    confirmBtn.id = 'et-wechsel-confirm'
    confirmBtn.type = 'button'
    confirmBtn.textContent = 'Bestätigen'
    confirmBtn.style.backgroundColor = '#000'
    confirmBtn.style.color = '#fff'
    confirmBtn.style.border = 'none'
    footerContainer.appendChild(cancelBtn)
    footerContainer.appendChild(confirmBtn)
    cancelBtnEl = cancelBtn
    confirmBtnEl = confirmBtn
  } else {
    footerContainer.innerHTML = `
      <button type="button" id="et-wechsel-cancel" style="padding:8px 15px;height:32px;font-size:14px;font-family:inherit;background:#fff;color:#000;border:1px solid #000;border-radius:4px;cursor:pointer;">Abbrechen</button>
      <button type="button" id="et-wechsel-confirm" style="padding:8px 15px;height:32px;font-size:14px;font-family:inherit;background:#000;color:#fff;border:none;border-radius:4px;cursor:pointer;">Bestätigen</button>
    `
    cancelBtnEl = box.querySelector('#et-wechsel-cancel')
    confirmBtnEl = box.querySelector('#et-wechsel-confirm')
  }

  function close() {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
  }

  overlay.addEventListener('click', (e) => { if (e.target === overlay) close() })
  cancelBtnEl.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    close()
  })
  const confirmLabel = confirmBtnEl.textContent
  confirmBtnEl.addEventListener('click', async (e) => {
    e.preventDefault()
    e.stopPropagation()
    const stichtag = stichtagPicker.getValue()
    const processSollstellungen = box.querySelector('#et-wechsel-sollstellungen').checked
    const processLastschriften = box.querySelector('#et-wechsel-lastschriften').checked
    const considerPaidHausgeld = box.querySelector('#et-wechsel-bereits-gezahlt').checked
    const authString = localStorage.getItem('auth')
    if (!authString) {
      alert('Fehler: Keine Anmeldung gefunden. Bitte erneut anmelden.')
      return
    }
    const authData = JSON.parse(authString)
    const token = authData?.token
    if (!token) {
      alert('Fehler: Kein Token gefunden.')
      return
    }
    const payload = {
      propertyHrId,
      unitId: parseInt(unitId, 10),
      oldContractId: parseInt(oldContractId, 10),
      stichtag,
      processSollstellungen,
      processLastschriften,
      considerPaidHausgeld,
    }
    confirmBtnEl.disabled = true
    cancelBtnEl.disabled = true
    confirmBtnEl.textContent = 'Bitte warten…'
    try {
      const response = await fetch(`${baseApiUrl}/api/et-wechsel`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
      const result = await response.json().catch(() => ({}))
      if (!response.ok) {
        const msg = result?.error || response.statusText
        const details = result?.details ? ` – ${result.details}` : ''
        confirmBtnEl.disabled = false
        cancelBtnEl.disabled = false
        confirmBtnEl.textContent = confirmLabel
        alert(`ET-Wechsel fehlgeschlagen: ${msg}${details}`)
        return
      }
      close()
      const report = result.report && result.report.length
        ? result.report.join('\n')
        : result.message || 'Fertig.'
      alert(result.message + '\n\n' + report)
    } catch (err) {
      console.error('ET-Wechsel request failed:', err)
      confirmBtnEl.disabled = false
      cancelBtnEl.disabled = false
      confirmBtnEl.textContent = confirmLabel
      alert('Fehler beim Aufruf: ' + (err && err.message ? err.message : 'Unbekannt'))
    }
  })
}

const getUnitContractContextFromUrl = () => {
  const urlPath = window.location.pathname
  const propertyMatch = urlPath.match(/properties\/([^/]+)\//)
  const unitMatch = urlPath.match(/\/unit\/([^/]+)\//)
  const contractMatch = urlPath.match(/contract\/all\/edit\/([^/?]+)/)

  return {
    propertyHrId: propertyMatch ? propertyMatch[1] : null,
    unitId: unitMatch ? unitMatch[1] : null,
    unitContractId: contractMatch ? parsePositiveIntId(contractMatch[1]) : null,
  }
}

const buildSepaTemplateHtml = ({ isWeg, contractPartnerLabel }) => `
  <style>
    @page {
      margin: 150px 80px 150px 80px;
    }
  </style>
  <div style='max-width: 97%;'>
  <br/>
    <strong>Bitte zurück an:</strong><br/><br/><br/>
    {{property.managementCompany.companyName}}<br/>
    {{property.managementCompany.addresses[0].street}} {{property.managementCompany.addresses[0].number}}<br/>
    {{property.managementCompany.addresses[0].postalCode}} {{property.managementCompany.addresses[0].city}}<br/><br/>
    <hr style="width: 100%; border: 1px solid black; margin: 10px 0;">
    <div style="text-align: right;">{{property.managementCompany.addresses[0].city}}, ${new Date().toLocaleDateString('de-DE')}</div>
  </div>
  <div style='margin-top: 0px; max-width: 97%; text-align: justify;'>
    <span style="font-weight: bold; text-decoration: underline;">SEPA-Lastschriftmandat</span><br/>
<br/>
<table style="width: 100%; margin-bottom: 20px; border-collapse: collapse; font-weight: bold;">
  <tr>
    <td style="padding-right: 20px;">Objekt:</td>
    <td>{{property.name}}</td>
  </tr>
  <tr>
    <td style="padding-right: 20px; vertical-align: top;">c/o:</td>
    <td>{{property.managementCompany.companyName}}<br/>{{property.managementCompany.addresses[0].street}} {{property.managementCompany.addresses[0].number}}, {{property.managementCompany.addresses[0].postalCode}} {{property.managementCompany.addresses[0].city}}</td>
  </tr>
  <tr>
    <td style="padding-right: 20px;">Gläubiger-ID:</td>
    <td>{{property.creditorId}}</td>
  </tr>
  <tr>
    <td style="padding-right: 20px;">Mandatsreferenz:</td>
    <td>{{mandateReference}}</td>
  </tr>
  <tr>
    <td style="padding-right: 20px;">Einheitsnummer:</td>
    <td>EH{{unit.unitNrSharingDeclaration}}</td>
  </tr>
  <tr>
    <td style="padding-right: 20px;">${contractPartnerLabel}:</td>
    <td>{{contractPartnerName}}</td>
  </tr>
</table>
${isWeg
    ? 'Ich/Wir ermächtige/n die {{propertyName}}, vertreten durch {{property.managementCompany.companyName}}, {{property.managementCompany.addresses[0].street}} {{property.managementCompany.addresses[0].number}}, {{property.managementCompany.addresses[0].postalCode}} {{property.managementCompany.addresses[0].city}}, die fälligen monatlichen Zahlungen (Hausgelder und Rücklagen) und Fehlbeträge aus Jahresabrechnungen'
    : 'Ich/Wir ermächtige/n den/die Eigentümer des Objekts, {{propertyOwners}}, vertreten durch {{property.managementCompany.companyName}}, {{property.managementCompany.addresses[0].street}} {{property.managementCompany.addresses[0].number}}, {{property.managementCompany.addresses[0].postalCode}} {{property.managementCompany.addresses[0].city}}, die fälligen monatlichen Mietzahlungen (Grundmiete und Betriebskosten) und Fehlbeträge aus Jahresabrechnungen'}

<br/><br/>
ab ………………………. von folgendem Konto durch SEPA-Lastschrift einzuziehen.
<br/><br/>

Zugleich weise/n ich/wir unser Kreditinstitut an, die vom Eigentümer des Objekts auf unser Konto gezogenen Lastschriften einzulösen.

  <table style="width: 100%; margin-top: 10px; margin-bottom: 20px; border-collapse: collapse;">
    <tr>
      <td style="padding: 10px 0px;">Vorname und Name d. Kontoinhabers</td>
      <td style="padding: 10px 0px;">________________________________</td>
    </tr>
    <tr>
      <td style="padding: 10px 0px;">Kreditinstitut (Name und BIC)</td>
      <td style="padding: 10px 0px;">________________________________</td>
    </tr>
    <tr>
      <td style="padding: 10px 0px;">IBAN:</td>
      <td style="padding: 10px 0px;">________________________________</td>
    </tr>
  </table>
  <div style="margin-top: 40px; display: flex; width: 100%;">
    <div style="width: 50%; text-align: left; display: flex; flex-direction: column; align-items: flex-start;">
      <div style="border-bottom: 1.5px solid #000; width: 80%; margin: 0 0 4px 0;"></div>
      <span>(Ort, Datum)</span>
    </div>
    <div style="width: 50%; text-align: left; display: flex; flex-direction: column; align-items: flex-start;">
      <div style="border-bottom: 1.5px solid #000; width: 80%; margin: 0 0 4px 0;"></div>
      <span>(Unterschrift)</span>
    </div>
  </div>
  <div style="margin-top: 10px;">
    <span>Diese Einzugsermächtigung ist jederzeit schriftlich widerrufbar.</span>
  </div>
  <div style="margin-top: 10px; font-size: 12px;">
    <span>HINWEIS: Wir können innerhalb von 8 Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit unserem Kreditinstitut vereinbarten Bedingungen.</span>
  </div>
  </div>
`

const unitContractSepaTemplates = [
  {
    name: 'Blanko SEPA',
    showFor: 'nonWEG',
    contractType: 'TENANT',
    prefilled: false,
    html: buildSepaTemplateHtml({ isWeg: false, contractPartnerLabel: 'Mieter' }),
  },
  {
    name: 'SEPA vorausgefüllt',
    showFor: 'nonWEG',
    contractType: 'TENANT',
    prefilled: true,
    html: buildSepaTemplateHtml({ isWeg: false, contractPartnerLabel: 'Mieter' }),
  },
  {
    name: 'Blanko SEPA (WEG)',
    showFor: 'WEG',
    contractType: 'OWNER',
    prefilled: false,
    html: buildSepaTemplateHtml({ isWeg: true, contractPartnerLabel: 'Eigentümer' }),
  },
  {
    name: 'SEPA vorausgefüllt (WEG)',
    showFor: 'WEG',
    contractType: 'OWNER',
    prefilled: true,
    html: buildSepaTemplateHtml({ isWeg: true, contractPartnerLabel: 'Eigentümer' }),
  },
]

const parseTemplatePropertyPath = (propertyPath) => {
  const parts = []
  let current = ''
  let inBrackets = false
  let bracketContent = ''

  for (let i = 0; i < propertyPath.length; i++) {
    const char = propertyPath[i]

    if (char === '[') {
      inBrackets = true
      if (current) {
        parts.push({ type: 'property', value: current })
        current = ''
      }
    } else if (char === ']') {
      inBrackets = false
      parts.push({ type: 'index', value: parseInt(bracketContent, 10) })
      bracketContent = ''
    } else if (char === '.') {
      if (!inBrackets) {
        if (current) {
          parts.push({ type: 'property', value: current })
          current = ''
        }
      } else {
        bracketContent += char
      }
    } else if (inBrackets) {
      bracketContent += char
    } else {
      current += char
    }
  }

  if (current) {
    parts.push({ type: 'property', value: current })
  }

  return parts
}

const getTemplateValueFromPath = (obj, pathParts) => {
  let value = obj

  for (const part of pathParts) {
    if (!value || typeof value !== 'object') return undefined

    if (part.type === 'property') {
      if (!(part.value in value)) return undefined
      value = value[part.value]
    } else if (part.type === 'index') {
      if (!Array.isArray(value) || part.value < 0 || part.value >= value.length) return undefined
      value = value[part.value]
    }
  }

  return value
}

const getContractDisplayName = (unitContractData) => {
  if (!unitContractData) return ''
  if (unitContractData.mailingContact?.name) return unitContractData.mailingContact.name

  const contactNames = Array.isArray(unitContractData.contacts)
    ? [...new Set(unitContractData.contacts.map((contact) => contact?.name).filter(Boolean))]
    : []

  return contactNames.join(', ')
}

const replaceSepaTemplateVariables = ({
  html,
  propertyData,
  unitsData,
  selectedUnitId,
  propertyOwnersData,
  unitContractData,
  mandateReference,
}) => {
  let processedHtml = html

  processedHtml = processedHtml.replace(/\{\{property\.([^}]+)\}\}/g, (match, propertyPath) => {
    const value = getTemplateValueFromPath(propertyData, parseTemplatePropertyPath(propertyPath))
    return value === undefined ? match : value !== null ? String(value) : ''
  })

  processedHtml = processedHtml.replace(/\{\{unit\.([^}]+)\}\}/g, (match, propertyPath) => {
    const unitsArray = Array.isArray(unitsData?.content) ? unitsData.content : unitsData
    if (!Array.isArray(unitsArray) || !selectedUnitId) return match

    const selectedUnit = unitsArray.find(
      (unit) => String(unit?.id) === String(selectedUnitId)
    )
    if (!selectedUnit) return match

    const value = getTemplateValueFromPath(selectedUnit, parseTemplatePropertyPath(propertyPath))
    return value === undefined ? match : value !== null ? String(value) : ''
  })

  processedHtml = processedHtml.replace(/\{\{propertyOwners\}\}/g, (match) => {
    const contractsArray = Array.isArray(propertyOwnersData?.content)
      ? propertyOwnersData.content
      : propertyOwnersData

    if (!Array.isArray(contractsArray)) return match

    const ownerNames = contractsArray
      .map((contract) => contract.mailingContact?.name)
      .filter(Boolean)

    return ownerNames.length > 0 ? ownerNames.join(', ') : match
  })

  processedHtml = processedHtml.replace(/\{\{propertyName\}\}/g, () => {
    return propertyData?.name || ''
  })

  processedHtml = processedHtml.replace(/\{\{mandateReference\}\}/g, () => mandateReference || '')
  processedHtml = processedHtml.replace(/\{\{contractPartnerName\}\}/g, () => {
    return getContractDisplayName(unitContractData)
  })

  return processedHtml
}

const fetchSepaPropertyData = async (propertyHrId, token) => {
  const response = await fetch(`/services/pmp-accounting/api/v1/properties/${propertyHrId}`, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch property data: ${response.statusText}`)
  }

  return response.json()
}

const fetchSepaUnitsData = async (propertyId, token) => {
  const response = await fetch(`/services/pmp-accounting/api/v1/units?propertyId=${propertyId}`, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch units data: ${response.statusText}`)
  }

  return response.json()
}

const fetchSepaPropertyOwnerContracts = async (propertyId, token) => {
  const response = await fetch(
    `/services/pmp-accounting/api/v1/contracts?propertyId=${propertyId}&type=PROPERTY_OWNER`,
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  )

  if (!response.ok) {
    throw new Error(`Failed to fetch property owner contracts: ${response.statusText}`)
  }

  return response.json()
}

const fetchSepaUnitContract = async (unitContractId, token) => {
  const response = await fetch(
    `/services/pmp-accounting/api/v1/unit-contract?unitContractIds=${encodeURIComponent(unitContractId)}`,
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  )

  if (!response.ok) {
    throw new Error(`Failed to fetch unit contract: ${response.statusText}`)
  }

  const data = await response.json()
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error('Kein passender Einheitenvertrag gefunden.')
  }

  return data[0]
}

const getAvailableSepaTemplates = (propertyData, unitContractData) => {
  const isWEG = propertyData?.administrationType === 'WEG'
  const contractType = unitContractData?.type

  return unitContractSepaTemplates.filter((template) => {
    if (template.contractType && template.contractType !== contractType) return false
    // Hausgeld mandates (WEG wording) only for Eigentümerverträge on WEG properties.
    if (template.showFor === 'WEG') return isWEG
    // Miet-Mandate for Mieterverträge on every property type (incl. WEG-owned units).
    if (template.showFor === 'nonWEG') return contractType === 'TENANT' || !isWEG
    return true
  })
}

const showSepaMandateModal = async (template, context) => {
  const token = JSON.parse(localStorage.getItem('auth'))?.token
  if (!token) throw new Error('Auth Token nicht gefunden.')

  const modalOverlay = document.createElement('div')
  modalOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  `

  const modalContent = document.createElement('div')
  modalContent.style.cssText = `
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: 1px solid #000;
  `

  const modalHeader = document.createElement('div')
  modalHeader.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8e8e8;
  `

  const modalTitle = document.createElement('h3')
  modalTitle.textContent = `Briefpapier für "${template.name}" auswählen`
  modalTitle.style.margin = '0'
  modalTitle.style.fontSize = '18px'
  modalTitle.style.fontWeight = '600'
  modalTitle.style.color = '#000'

  const closeButton = document.createElement('button')
  closeButton.innerHTML = '×'
  closeButton.style.cssText = `
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #000;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  const removeModal = () => {
    if (modalOverlay.parentNode) {
      modalOverlay.parentNode.removeChild(modalOverlay)
    }
  }

  closeButton.addEventListener('click', removeModal)
  modalHeader.appendChild(modalTitle)
  modalHeader.appendChild(closeButton)

  const loadingIndicator = document.createElement('div')
  loadingIndicator.style.cssText = `
    text-align: center;
    padding: 20px;
    color: #666;
  `
  loadingIndicator.innerHTML = `
    <div style="margin-bottom: 10px;">Lade Daten...</div>
    <div style="width: 100%; height: 4px; background-color: #f0f0f0; border-radius: 2px; overflow: hidden;">
      <div id="loading-progress" style="width: 0%; height: 100%; background-color: #000; transition: width 0.3s ease;"></div>
    </div>
  `

  const watermarkSelection = document.createElement('div')
  watermarkSelection.style.cssText = `
    margin-bottom: 20px;
    display: none;
  `

  const watermarkLabel = document.createElement('label')
  watermarkLabel.textContent = 'Briefpapier auswählen:'
  watermarkLabel.style.cssText = `
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #000;
  `

  const watermarkSelect = document.createElement('select')
  watermarkSelect.style.cssText = `
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #000;
    border-radius: 6px;
    font-size: 14px;
    background-color: white;
    cursor: pointer;
    color: #000;
  `

  watermarkSelection.appendChild(watermarkLabel)
  watermarkSelection.appendChild(watermarkSelect)

  const mandateReferenceSelection = document.createElement('div')
  mandateReferenceSelection.style.cssText = `
    margin-bottom: 20px;
    display: none;
  `

  const mandateReferenceLabel = document.createElement('label')
  mandateReferenceLabel.textContent = 'Mandatsreferenz'
  mandateReferenceLabel.style.cssText = `
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #000;
  `

  const mandateReferenceInput = document.createElement('input')
  mandateReferenceInput.type = 'text'
  mandateReferenceInput.placeholder = 'Optional manuell überschreiben'
  mandateReferenceInput.style.cssText = `
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #000;
    border-radius: 6px;
    font-size: 14px;
    background-color: white;
    color: #000;
    box-sizing: border-box;
  `

  mandateReferenceSelection.appendChild(mandateReferenceLabel)
  mandateReferenceSelection.appendChild(mandateReferenceInput)

  const actionButtons = document.createElement('div')
  actionButtons.style.cssText = `
    display: none;
    gap: 12px;
    justify-content: flex-end;
  `

  const modalCloseButton = document.createElement('button')
  modalCloseButton.textContent = 'Schließen'
  modalCloseButton.style.cssText = `
    background-color: white;
    border: 1px solid #000;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #000;
  `
  modalCloseButton.addEventListener('click', removeModal)

  const downloadButton = document.createElement('button')
  downloadButton.textContent = 'Herunterladen'
  downloadButton.style.cssText = `
    background-color: #000;
    border: 1px solid #000;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: white;
    font-weight: 500;
  `

  actionButtons.appendChild(modalCloseButton)
  actionButtons.appendChild(downloadButton)

  modalContent.appendChild(modalHeader)
  modalContent.appendChild(loadingIndicator)
  modalContent.appendChild(watermarkSelection)
  modalContent.appendChild(mandateReferenceSelection)
  modalContent.appendChild(actionButtons)
  modalOverlay.appendChild(modalContent)
  document.body.appendChild(modalOverlay)

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) removeModal()
  })

  const progressBar = loadingIndicator.querySelector('#loading-progress')

  try {
    progressBar.style.width = '25%'
    const propertyData = await fetchSepaPropertyData(context.propertyHrId, token)

    const propertyId = propertyData.id || propertyData.propertyId
    if (!propertyId) {
      throw new Error('Property ID not found in property data')
    }

    progressBar.style.width = '50%'
    const unitsData = await fetchSepaUnitsData(propertyId, token)

    progressBar.style.width = '75%'
    const propertyOwnersData = await fetchSepaPropertyOwnerContracts(propertyId, token)

    progressBar.style.width = '85%'
    const unitContractData = await fetchSepaUnitContract(context.unitContractId, token)

    progressBar.style.width = '95%'
    const watermarkResponse = await fetch(
      '/services/pmp-document/api/v1/documents?sourceTypes=WATERMARK',
      {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
    )

    if (!watermarkResponse.ok) {
      throw new Error('Failed to fetch watermarks')
    }

    const watermarkData = await watermarkResponse.json()
    const watermarks = watermarkData.content || []
    progressBar.style.width = '100%'

    setTimeout(() => {
      loadingIndicator.style.display = 'none'
      watermarkSelection.style.display = 'block'
      mandateReferenceSelection.style.display = 'block'
      actionButtons.style.display = 'flex'

      mandateReferenceInput.value =
        template.prefilled && unitContractData?.contractNumber
          ? unitContractData.contractNumber
          : ''

      if (watermarks.length === 0) {
        const noWatermarksOption = document.createElement('option')
        noWatermarksOption.value = ''
        noWatermarksOption.textContent = 'Keine Briefpapiere verfügbar'
        noWatermarksOption.disabled = true
        watermarkSelect.appendChild(noWatermarksOption)
      } else {
        let defaultWatermarkIndex = -1

        watermarks.forEach((watermark, index) => {
          try {
            const metadata = watermark.metaData ? JSON.parse(watermark.metaData) : {}
            if (metadata.isDefault === true) {
              defaultWatermarkIndex = index
            }
          } catch (error) {
            console.warn('Error parsing watermark metadata:', error)
          }
        })

        watermarks.forEach((watermark, index) => {
          const option = document.createElement('option')
          option.value = watermark.id
          option.textContent = watermark.name
          option.selected =
            defaultWatermarkIndex !== -1
              ? index === defaultWatermarkIndex
              : index === watermarks.length - 1
          watermarkSelect.appendChild(option)
        })
      }

      downloadButton.addEventListener('click', async () => {
        const selectedWatermarkId = watermarkSelect.value
        if (!selectedWatermarkId) {
          alert('Bitte wählen Sie ein Briefpapier aus.')
          return
        }

        const processedHtml = replaceSepaTemplateVariables({
          html: template.html,
          propertyData,
          unitsData,
          selectedUnitId: context.unitId || unitContractData?.unitId,
          propertyOwnersData,
          unitContractData: template.prefilled ? unitContractData : null,
          mandateReference: mandateReferenceInput.value.trim(),
        })

        const originalText = downloadButton.textContent
        downloadButton.textContent = 'Generiere PDF...'
        downloadButton.style.backgroundColor = '#666'
        downloadButton.style.borderColor = '#666'
        downloadButton.style.cursor = 'not-allowed'
        downloadButton.disabled = true

        try {
          const response = await fetch('/services/pmp-document/api/v1/templates/render', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            },
            body: JSON.stringify({
              convertToPdfA: true,
              convertToPdfA1b: true,
              displayHeaderFooter: true,
              html: processedHtml,
              useLegacyPdfRenderer: false,
              watermarkId: parseInt(selectedWatermarkId, 10),
              withPageNumbering: false,
            }),
          })

          if (!response.ok) {
            throw new Error('Failed to generate PDF: ' + response.statusText)
          }

          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `${template.name}.pdf`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          removeModal()
        } catch (error) {
          console.error('Error generating PDF:', error)
          alert('Fehler beim Generieren der PDF: ' + error.message)
          downloadButton.textContent = originalText
          downloadButton.style.backgroundColor = '#000'
          downloadButton.style.borderColor = '#000'
          downloadButton.style.cursor = 'pointer'
          downloadButton.disabled = false
        }
      })
    }, 300)
  } catch (error) {
    console.error('Error loading SEPA modal data:', error)
    loadingIndicator.innerHTML = `
      <div style="color: #d32f2f; margin-bottom: 10px;">Fehler beim Laden der Daten:</div>
      <div style="color: #666; font-size: 14px;">${error.message}</div>
      <button onclick="location.reload()" style="margin-top: 10px; padding: 8px 16px; background-color: #000; color: white; border: none; border-radius: 4px; cursor: pointer;">
        Erneut versuchen
      </button>
    `
  }
}

const ensureSepaDocumentsDropdown = (headerButtons) => {
  if (!headerButtons || headerButtons.querySelector('[data-testid="unit-contract-sepa-dropdown"]')) {
    return
  }

  const dropdownContainer = document.createElement('div')
  dropdownContainer.setAttribute('data-testid', 'unit-contract-sepa-dropdown')
  dropdownContainer.style.position = 'relative'
  dropdownContainer.style.display = 'inline-block'

  const dropdownButton = document.createElement('button')
  dropdownButton.type = 'button'
  dropdownButton.className =
    'ant-btn ant-btn-ghost Button ant-dropdown-trigger DropdownButton with-icon'
  dropdownButton.innerHTML =
    '<span>Dokumente</span><span role="img" class="anticon"><svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="white"></path></svg></span>'

  const dropdownMenu = document.createElement('div')
  dropdownMenu.style.position = 'absolute'
  dropdownMenu.style.top = '100%'
  dropdownMenu.style.left = '0'
  dropdownMenu.style.backgroundColor = 'white'
  dropdownMenu.style.border = '1px solid #d9d9d9'
  dropdownMenu.style.borderRadius = '6px'
  dropdownMenu.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)'
  dropdownMenu.style.zIndex = '1000'
  dropdownMenu.style.display = 'none'
  dropdownMenu.style.minWidth = '180px'

  const closeDropdown = () => {
    dropdownMenu.style.display = 'none'
  }

  dropdownButton.addEventListener('click', async (e) => {
    e.stopPropagation()
    const isVisible = dropdownMenu.style.display === 'block'
    if (isVisible) {
      closeDropdown()
      return
    }

    try {
      const token = JSON.parse(localStorage.getItem('auth'))?.token
      if (!token) throw new Error('Auth Token nicht gefunden.')

      const context = getUnitContractContextFromUrl()
      if (!context.propertyHrId || !context.unitContractId) {
        throw new Error('Kontext für Einheitenvertrag konnte nicht ermittelt werden.')
      }

      const [propertyData, unitContractData] = await Promise.all([
        fetchSepaPropertyData(context.propertyHrId, token),
        fetchSepaUnitContract(context.unitContractId, token),
      ])

      const filteredTemplates = getAvailableSepaTemplates(propertyData, unitContractData)
      dropdownMenu.innerHTML = ''

      if (filteredTemplates.length === 0) {
        alert('Für diesen Vertrag ist kein passendes SEPA-Mandat verfügbar.')
        return
      }

      filteredTemplates.forEach((template, index) => {
        const option = document.createElement('div')
        option.style.padding = '8px 12px'
        option.style.cursor = 'pointer'
        option.style.borderBottom =
          index < filteredTemplates.length - 1 ? '1px solid #f0f0f0' : 'none'
        option.textContent = template.name
        option.addEventListener('mouseenter', () => {
          option.style.backgroundColor = '#f5f5f5'
        })
        option.addEventListener('mouseleave', () => {
          option.style.backgroundColor = 'white'
        })
        option.addEventListener('click', async () => {
          closeDropdown()
          await showSepaMandateModal(template, context)
        })
        dropdownMenu.appendChild(option)
      })

      dropdownMenu.style.display = 'block'
    } catch (error) {
      console.error('Error preparing SEPA dropdown:', error)
      alert('Fehler beim Laden der SEPA-Dokumente: ' + error.message)
    }
  })

  document.addEventListener('click', (e) => {
    if (!dropdownContainer.contains(e.target)) closeDropdown()
  })

  dropdownContainer.appendChild(dropdownButton)
  dropdownContainer.appendChild(dropdownMenu)
  headerButtons.insertBefore(dropdownContainer, headerButtons.children[1] || null)
}

const onContractsPageMatch = () => {
  // Native rent-plan overlays have their own injector; do not decorate their headers.
  if (/\/rent-plan\//.test(window.location.pathname)) return
  mountLuxProratedFirstMonthRent()
  const isContractCreatePage = () => /\/contract\/all\/create\/?$/.test(window.location.pathname)
  const isContractEditorPage = () => /\/contract\/all\/(?:create|edit\/[^/]+)\/?$/.test(window.location.pathname)

  let pollAttempts = 0
  const MAX_POLL_ATTEMPTS = 150 // 15s at 100ms

  const waitForPageLoad = setInterval(() => {
    pollAttempts += 1
    if (pollAttempts >= MAX_POLL_ATTEMPTS || !isContractEditorPage()) {
      clearInterval(waitForPageLoad)
      return
    }

    const tenantEditor = document.querySelector('.TenantContractEditor')
    const ownerEditor = document.querySelector('.OwnerContractEditor')
    const contractCtx = getUnitContractContextFromUrl()

    if (tenantEditor || ownerEditor) {
      injectVertragsverteilungExcludeAll(contractCtx)
    }

    // Create page: only inject contract documents section (no SEPA / Kautionsassistent).
    if (tenantEditor && isContractCreatePage()) {
      injectContractDocuments(contractCtx)
      const section = document.getElementById('lux-contract-documents-section')
      if (section?.querySelector('#contract-document-upload-button')) {
        clearInterval(waitForPageLoad)
      } else if (!contractCtx.propertyHrId) {
        // Missing URL context — injection cannot succeed.
        clearInterval(waitForPageLoad)
      }
      return
    }

    // Append order must match section numbers: 5, 6, then 7 (each uses pageContent.appendChild).
    if (tenantEditor && contractCtx.unitContractId) {
      injectRentFreePeriods(contractCtx)
      injectRentalAdaptation(contractCtx)
    }
    if ((tenantEditor || ownerEditor) && contractCtx.unitContractId) {
      injectUnitContractNotes(contractCtx)
    }
    // BKA checkboxes: owner contracts in WEG properties only (EHV-1031).
    if (ownerEditor && contractCtx.unitContractId) {
      injectUnitContractBka(contractCtx)
    }
    const headerButtons = document.querySelector('.header-buttons')

    // --- Owner Contract: ET-Wechsel button ---
    if (ownerEditor && headerButtons && headerButtons.firstElementChild) {
      ensureSepaDocumentsDropdown(headerButtons)
      if (!headerButtons.querySelector('#et-wechsel-button')) {
        const clonedBtn = headerButtons.firstElementChild.cloneNode(true)
        clonedBtn.id = 'et-wechsel-button'
        clonedBtn.textContent = 'ET-Wechsel'
        clonedBtn.style.backgroundColor = '#1a5f4a'
        clonedBtn.style.color = 'white'
        headerButtons.insertBefore(clonedBtn, headerButtons.children[1])

        clonedBtn.addEventListener('click', () => openEtWechselDialog())
      }
      if (headerButtons.querySelector('#et-wechsel-button')) {
        clearInterval(waitForPageLoad)
      }
      return
    }

    // --- Tenant: SEPA Dokumente dropdown + Kautionsassistent; Vertragsdokumente in section ---
    const pageContent = tenantEditor

    if (tenantEditor) {
      injectContractDocuments(contractCtx)
    }

    if (pageContent && headerButtons && headerButtons.firstElementChild) {
      ensureSepaDocumentsDropdown(headerButtons)

      if (!headerButtons.querySelector('#kautionsassistent-button')) {
        const clonedButton = headerButtons.firstElementChild.cloneNode(true)
        clonedButton.id = 'kautionsassistent-button'
        clonedButton.textContent = 'Kautionsassistent'
        clonedButton.style.backgroundColor = 'black'
        clonedButton.style.color = 'white'
        headerButtons.insertBefore(clonedButton, headerButtons.children[1])

        clonedButton.addEventListener('click', () => {
          const authString = localStorage.getItem('auth');
          if (!authString) {
            console.error('Kautionsassistent Error: Auth not found in localStorage.');
            alert("Fehler: Kautionsassistent erfordert eine aktive Anmeldung.");
            return;
          }

          const authData = JSON.parse(authString);
          const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
          const email = decodedToken.sub
          const domainId = decodedToken.domainId

          try {
            if (!authData || !authData.token || !domainId || !email) {
              throw new Error("Invalid auth data structure.");
            }
          } catch (error) {
            console.error('Kautionsassistent Error: Failed to parse auth data from localStorage:', error);
            alert("Fehler: Ungültige Anmeldedaten gefunden.");
            return;
          }

          let propertyHrId = null;
          let unitContractId = null;
          const urlPath = window.location.pathname;
          const urlMatch = urlPath.match(/properties\/([^/]+)\/.*?\/edit\/([^/?]+)/);

          if (urlMatch && urlMatch.length >= 3) {
              propertyHrId = urlMatch[1];
              unitContractId = urlMatch[2];
          } else {
              console.error('Kautionsassistent Error: Could not extract propertyHrId and unitContractId from URL:', urlPath);
              alert("Fehler: Kontext für Kautionsassistent konnte nicht ermittelt werden (IDs nicht gefunden).");
              return;
          }

          
          var iframe = document.createElement('iframe')
          const iframeSrc = `${baseApiUrl}/injects/kaution?propertyHrId=${encodeURIComponent(propertyHrId)}&unitContractId=${encodeURIComponent(unitContractId)}&domainId=${encodeURIComponent(domainId)}&userEmail=${encodeURIComponent(email)}&pw=OsAK1823`;
          iframe.style.width = '100%'
          iframe.style.height = '100%'
          iframe.style.border = 'none'
          iframe.style.display = 'none'
          iframe.style.backgroundColor = 'transparent'

          var overlay = document.createElement('div')
          overlay.style.position = 'fixed'
          overlay.style.top = '0'
          overlay.style.left = '0'
          overlay.style.width = '100%'
          overlay.style.height = '100%'
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
          overlay.style.zIndex = '10000'
          overlay.style.display = 'flex'
          overlay.style.justifyContent = 'center'
          overlay.style.alignItems = 'center'
          
          var loadingContainer = document.createElement('div')
          loadingContainer.style.backgroundColor = 'white'
          loadingContainer.style.padding = '20px'
          loadingContainer.style.borderRadius = '8px'
          loadingContainer.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'
          loadingContainer.style.display = 'flex'
          loadingContainer.style.flexDirection = 'column'
          loadingContainer.style.alignItems = 'center'
          loadingContainer.style.justifyContent = 'center'
          
          var spinner = document.createElement('div')
          spinner.style.width = '40px'
          spinner.style.height = '40px'
          spinner.style.border = '4px solid rgba(0, 0, 0, 0.1)'
          spinner.style.borderRadius = '50%'
          spinner.style.borderTop = '4px solid #3498db'
          spinner.style.animation = 'spin 1s linear infinite'
          
          var style = document.createElement('style')
          style.innerHTML = `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `
          document.head.appendChild(style)
          
          var loadingText = document.createElement('div')
          loadingText.textContent = 'Laden...'
          loadingText.style.marginTop = '10px'
          loadingText.style.fontFamily = 'Arial, sans-serif'
          loadingText.style.fontSize = '16px'
          
          loadingContainer.appendChild(spinner)
          loadingContainer.appendChild(loadingText)
          
          overlay.appendChild(loadingContainer)
          
          document.body.appendChild(overlay)

          overlay.appendChild(iframe)          
          iframe.src = iframeSrc;


          iframe.onload = function() {
              loadingContainer.style.display = 'none'
              iframe.style.display = 'block'
              overlay.style.backgroundColor = 'transparent'
          }

          window.addEventListener('message', (event) => {
            if (event.data.type === 'CLOSE_DEPOSIT_MODAL') {
              document.body.removeChild(overlay)
              document.head.removeChild(style)
            } else if (event.data.type === 'redirectToPath') {
              window.location.href = event.data.path
            }
          });
        })
      }

      const hasSepa = headerButtons.querySelector('[data-testid="unit-contract-sepa-dropdown"]')
      const hasKautionsassistent = headerButtons.querySelector('#kautionsassistent-button')
      if (hasSepa && hasKautionsassistent) {
        clearInterval(waitForPageLoad)
      }
    }
  }, 100)
}